export const CREATE_PROMOTION = 'CREATE_PROMOTION';
export const UPSERT_PROMOTION = 'UPSERT_PROMOTION';
export const EDIT_PROMOTION = 'EDIT_PROMOTION';
export const DELETE_PROMOTION = 'DELETE_PROMOTION';
export const LIST_PROMOTIONS = 'LIST_PROMOTIONS';
export const BOOST_PROMOTION = 'BOOST_PROMOTION';
export const CANCEL_BOOST_PROMOTION = 'CANCEL_BOOST_PROMOTION';
export const SET_BOOST_LIST = 'SET_BOOST_LIST';